export default __webpack_public_path__ + "static/media/Rafa.f7346407.jpeg";